export default __webpack_public_path__ + "static/media/ic_base_24.c70c2717.svg";